import { Injectable } from '@angular/core';
import {BaseReactiveStore} from "../../shared/base-reactive-store";
import {Observable} from "rxjs";

export class ApiLoadingServiceState {
  inProgress: number = 0
}

@Injectable({
  providedIn: 'root'
})
export class ApiLoadingService extends BaseReactiveStore<ApiLoadingServiceState>{

  $isCommunicating: Observable<boolean> =
    this.select(state => state.inProgress > 0)


  constructor()
  {
    super(new ApiLoadingServiceState())
  }

  public addInProgress(): void {
    this.setState({inProgress: this.state.inProgress + 1})
  }

  public decrementInProgress(): void {
    this.setState({inProgress: this.state.inProgress - 1})
  }


}
